module.exports = __webpack_public_path__ + "img/Wp_2070.67f43b6f.png";